/**
 * IT Companies - All Projects Page
 * Software development and IT projects management
 */

import { useEffect } from 'react';
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function ITCompaniesProjectsPage() {
  useEffect(() => {
    document.title = 'Todos os Projetos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <AllProjectsPage
        domain={CompanyType.IT_COMPANIES}
        title="Todos os Projetos"
        description="Gerencie seus projetos de desenvolvimento e TI"
        createButtonLabel="Novo Projeto"
      />
    </div>
  
    </MainLayout>);
}

